import { Icon } from "pepsico-ds";
import PropTypes from "prop-types";
import CommonTableView from "../common/CommonTable/CommonTableView";
import SurveySourceBadge from "./SurveySourceBadge";

const AvailableSurveysListView = ({ rows, generateActionButtons }) => {
  // CommonTableView derives columns from each row's keys (in insertion order) and
  // uses columnConfig for labels and custom cell rendering.
  const tableRows = rows.map((row) => ({
    surveyName: row.surveyName,
    surveyId: row.surveyId,
    source: row.source,
    surveyUrl: row.surveyUrl,
    actions: row,
  }));

  const columnConfig = {
    surveyName: { label: "SURVEY NAME" },
    surveyId: { label: "SURVEY ID" },
    source: {
      label: "SOURCE",
      render: (value) => <SurveySourceBadge source={value} />,
    },
    surveyUrl: { label: "SURVEY URL" },
    actions: {
      // Single space keeps the column header blank (CommonTableView falls back to a
      // prettified key name for an empty-string label).
      label: " ",
      render: (row) => (
        <div className="survey-actions">
          {generateActionButtons(row).map((btn) => (
            <button
              key={btn.icon}
              type="button"
              className="survey-actions__btn"
              aria-label={btn.icon}
              disabled={btn.disabled}
              onClick={btn.onClick}
            >
              <Icon icon={btn.icon} size="small" />
            </button>
          ))}
        </div>
      ),
    },
  };

  return <CommonTableView contentList={tableRows} columnConfig={columnConfig} />;
};

AvailableSurveysListView.propTypes = {
  rows: PropTypes.array.isRequired,
  generateActionButtons: PropTypes.func.isRequired,
};

export default AvailableSurveysListView;
